
import '../common/common';

import $ from "jquery";
import { populateModel, populateBrands, getModelInfo } from "../lib/modelLookup";

function getQueryParams(url: string) {
  const paramArr = url.slice(url.indexOf("?") + 1).split("&");
  const params: Record<string, string> = {};
  paramArr.map((param) => {
    const [key, val] = param.split("=");
    params[key] = decodeURIComponent(val);
  });
  return params;
}

$(() => {
  const brandSelector = $("#radioBrandSelector");
  const modelSelector = $("#radioModelSelector");

  $(".modelSelectorForm").trigger("reset");

  brandSelector.on("change", function () {
    if (brandSelector.children(":selected").val()) {
      brandSelector.removeClass("text-ss-grey");
    } else {
      brandSelector.addClass("text-ss-grey");
    }
    if (!brandSelector.val()) {
      navigateToShop();
      return;
    }
    populateModel(brandSelector, modelSelector);
  });
  modelSelector.on("change", function () {
    if (modelSelector.children(":selected").val()) {
      modelSelector.removeClass("text-ss-grey");
    } else {
      modelSelector.addClass("text-ss-grey");
    }
    const brand = brandSelector.val();
    const model = modelSelector.val();
    if (!brand || !model) {
      navigateToShop();
      return;
    }
    filterByModel(brand as string, model as string);
    // Update the URL search params without reloading the page
    const location = window.location;
    const newUrl = `${location.origin}${location.pathname}`
      + `?brand=${brand}&model=${model}`;
    window.history.pushState({ path: newUrl }, "", newUrl);
  });

  $("#modelSelectorForm").on("submit", function (e) {
    e.preventDefault();
    const brand = brandSelector.val();
    const model = modelSelector.val();
    filterByModel(brand as string, model as string);
  });

  // Watch for history changes (back/forward navigation)
  window.addEventListener("popstate", initializeSelectorsAndPopulate);

  initializeSelectorsAndPopulate();

  function initializeSelectorsAndPopulate() {
    const {brand, model} = getQueryParams(window.location.href);

    populateBrands(brandSelector);
    if (brand) {
      brandSelector.val(brand);
      brandSelector.removeClass("text-ss-grey");
    } else {
      brandSelector.addClass("text-ss-grey");
    }
    populateModel(brandSelector, modelSelector);
    if (model) {
      modelSelector.val(model);
      modelSelector.removeClass("text-ss-grey");
    } else {
      modelSelector.addClass("text-ss-grey");
    }
    filterByModel(brand, model);
  }

  function filterByModel(brand: string, model: string) {
    window.plausible?.("shop-filter", { props: { brand, model } });
    const modelInfo = getModelInfo(brand, model);
    if (!modelInfo) {
      navigateToShop();
      return;
    }

    let text = `${modelInfo.connector} connector fits your model`;
    const spacerNumber = isNaN(Number(modelInfo.spacer))
      ? 0
      : Number(modelInfo.spacer);
    let show3d = false;
    let showSpacer = false;
    if (modelInfo.spacer == "3d") {
      text += `, and we recommend adding a 3D-printed spacer`;
      show3d = true;
    } else if (modelInfo.spacer == "?") {
      text += `. We don't know if a spacer is recommended`;
      showSpacer = true;
    } else if (spacerNumber == 0) {
      text += ` with no spacer needed`;
    } else if (spacerNumber == 1) {
      text += `, and we recommend adding a spacer`;
      showSpacer = true;
    } else {
      text += `, and we recommend adding ${spacerNumber} spacers`;
      showSpacer = true;
    }
    const textEl = $("#customized-shop-text");
    textEl.empty();
    textEl.append(text);
    textEl.show();

    const prodCards = $(".prod-card");
    if (prodCards.length > 0) {
      prodCards.each((index, product) => {
        const connector = $(product).data("connector").toLowerCase().replace(/[\[\]]/g, "").split(" ");
        if (connector.includes(modelInfo.connector.toLowerCase())) {
          $(product).parent().show();
        } else {
          const slug = $(product).data("slug");
          if (slug == "spacer-3dprinted") {
            if (show3d) {
              $(product).parent().show();
            } else {
              $(product).parent().hide();
            }
          } else if (slug == "spacer-rubber") {
            if (showSpacer) {
              $(product).parent().show();
            } else {
              $(product).parent().hide();
            }
          } else {
            $(product).parent().hide();
          }
        }
      });
    }
  }

  function navigateToShop() {
    window.location.href = "/shop";
  }
});
